/*================ Newton Code: Script for Buttons on Right Div ================*/

  
async function tableText() {
//    alert(this.href);
//    document.getElementById('get_url').href = this.href;
  	var whatisthis = this.id;
  	var openthis = "https://ghmvpso.org/pages/" + whatisthis;
  	document.getElementById('get_url').href = openthis;
    var imagePath = this.name;
    var fileName = getFileName(imagePath);
    document.getElementById('save_url').setAttribute('download', fileName);
    document.getElementById('iframe1').src = this.name;
  

}
  
//async function openList() {
//    var w = window.open('https://great-hearts-monte-vista-pso.myshopify.com/pages/viewer');
//    w.document.getElementsByTagName('img')[0]
//	var img = document.createElement('img');
//	img.src = this.href;
//    document.getElementById('viewdoc').appendChild(img);
//  } 


//    alert('The value of the imagePath attribute of the link is : ' +fileName);
//    document.getElementById('save_url').addEventListener('click', function() {
//    doc.output(imagePath, fileName);
//  });
  
  
 
function getFileName(str) {
    return str.substring(str.lastIndexOf('/') + 1)
}
                                                         
var cells = document.querySelectorAll('td > a');

for (var i = 0; i < cells.length; i++){
  cells[i].addEventListener('click', tableText);
  
};  



/*================ Newton Code: Script for Show/Hide Section ================*/
function showSection(element) {
  var x = document.getElementById(element);
  if (x.style.display !== "block") {
  x.style.display = "block";
  } else {
  x.style.display = "none";
  }
};


/*================ Newton Code: Script for Password Protected Page ================*/
    (function() {

        var pl = "BZqZoMTv2FJ4aRbzz7x2LmF0QsYR2IP4KArSWkfRAAep5PMmgZqCSQ/91uyUjBUTWTY9XDVTNgrfCK0OFmyqt1v7qWl+rmTgHpBAEdMG4hQqC2cuUV5FQKue3zfxAmJYYI+mPhDjID7AUk+K12HwXOD2dthEfXdBDkNtfDYjWAnEtkN9QzHdIjVJ";
        
        var submitPass = document.getElementById('submitPass');
        var passEl = document.getElementById('pass');
        var invalidPassEl = document.getElementById('invalidPass');
        var trycatcherror = document.getElementById('trycatcherror');
        var successEl = document.getElementById('success');
        var contentFrame = document.getElementById('contentFrame');

        // Sanity checks
      
        if (pl === "") {
            submitPass.disabled = true;
            passEl.disabled = true;
            alert("This page is meant to be used with the encryption tool. It doesn't work standalone.");
            return;
        }

        if (!isSecureContext) {
            document.querySelector("#passArea").style.display = "none";
            document.querySelector("#securecontext").style.display = "block";
            return;
        }

        if (!crypto.subtle) {
            document.querySelector("#passArea").style.display = "none";
            document.querySelector("#nocrypto").style.display = "block";
            return;
        }
        
        function str2ab(str) {
            var ustr = atob(str);
            var buf = new ArrayBuffer(ustr.length);
            var bufView = new Uint8Array(buf);
            for (var i=0, strLen=ustr.length; i < strLen; i++) {
                bufView[i] = ustr.charCodeAt(i);
            }
            return bufView;
        }

        async function deriveKey(salt, password) {
            const encoder = new TextEncoder()
            const baseKey = await crypto.subtle.importKey(
                'raw',
                encoder.encode(password),
                'PBKDF2',
                false,
                ['deriveKey'],
            )
            return await crypto.subtle.deriveKey(
                { name: 'PBKDF2', salt, iterations: 100000, hash: 'SHA-256' },
                baseKey,
                { name: 'AES-GCM', length: 256 },
                true,
                ['decrypt'],
            )
        }
        
        async function doSubmit(evt) {
            submitPass.disabled = true;
            passEl.disabled = true;

            let iv, ciphertext, key;
            
            try {
                var unencodedPl = str2ab(pl);

                const salt = unencodedPl.slice(0, 32)
                iv = unencodedPl.slice(32, 32 + 16)
                ciphertext = unencodedPl.slice(32 + 16)

                key = await deriveKey(salt, passEl.value);
            } catch (e) {
                trycatcherror.style.display = "inline";
                console.error(e);
                return;
            }

            try {
                const decryptedArray = new Uint8Array(
                    await crypto.subtle.decrypt({ name: 'AES-GCM', iv }, key, ciphertext)
                );

                let decrypted = new TextDecoder().decode(decryptedArray);

                if (decrypted === "") throw "No data returned";
              
                // Set default iframe link targets to _top so all links break out of the iframe
                decrypted = decrypted.replace("<head>", "<head><base href=\".\" target=\"_top\">");
                
                contentFrame.srcdoc = decrypted;
                
                successEl.style.display = "inline";
                setTimeout(function() {
                    dialogWrap.style.display = "none";
                    contentFrame.style.display = "none";
                }, 1000);
            } catch (e) {
                invalidPassEl.style.display = "inline";
                passEl.value = "";
                submitPass.disabled = false;
                passEl.disabled = false;
                console.error(e);
                return;
            }
        }
        
        submitPass.onclick = doSubmit;
        passEl.onkeypress = function(e){
            if (!e) e = window.event;
            var keyCode = e.keyCode || e.which;
            invalidPassEl.style.display = "none";
            if (keyCode == '13'){
              // Enter pressed
              doSubmit();
              return false;
            }
        } 
    
})();
